import React from 'react';

export default function LocationMap() {
  return (
    <div className="map-container" style={{ margin: '1.5rem 0' }}>
      <iframe
        title="Bounce It Up Location"
        width="100%"
        height="250"
        style={{ borderRadius: '12px', border: 'none' }}
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=Bounce+It+Up,30276+Plymouth+Rd,Livonia+MI`}
        allowFullScreen
      />
    </div>
  );
} 